<template>
  <div class="gj-table-wrapper-loading">
    <div>
      <app-filter-group :reset="false" :isBr="false" :query="false" style="margin-bottom: 12px;">
        <gj-input
            width="140px"
            placeholder="SKU/产品名称"
            v-model="keyword"
            @input="debounceQuery"
        ></gj-input>
        <gj-date-picker
            type="daterange"
            v-model="date"
            @input="debounceQuery"
        ></gj-date-picker>
        <template #right>
          <gj-tool-group
              download
              :download-url="`/supply/supplier/export/quote/${code}`"
              :download-params="globalParams"
          >
          </gj-tool-group>
        </template>
      </app-filter-group>
    </div>
    <gj-table
        :data="tableData"
        adaptParent
        :columns="columns"
        :adapt-height="false"
        :height="445"
        :index="false"
    >
      <template v-slot:productInfo="{row}">
        <div>
          <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
        </div>
        <div>
          <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
        </div>
      </template>
      <template v-slot:op="{row}">
        <gj-button type="text" @click="openQuotedPriceSupplier(row)">报价</gj-button>
        <gj-button type="text" @click="openQuotedHistory(row)">历史报价</gj-button>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import SupplierAddQuotedPrice from "../modal/supplier-add-quoted-price";
  import SupplierQuotedHistory from './supplier-detail-quoted-history';
  import {getQuoteInfo} from "@/api/purchase";
  import {isMeaningful} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";


  export default {
    name: "app-supplier-detail-quoted-info",
    mixins: [queryMixin],
    props: {
      id: null,
      name: null,
      code: null,
      mountTo: {
        required: true
      }
    },
    created() {
      this.queryQuoteInfo();
    },
    data() {
      return {
        columns: [
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '140px'},
          {id: 'moq', header: '最小起订量', field: 'moq', minWidth: '100px'},
          {id: 'purchaseDeliveryDays', header: '采购交期(天)', field: 'purchaseDeliveryDays', minWidth: '100px'},
          {id: 'purchaseUrl', header: '采购网址', field: 'purchaseUrl', minWidth: '100px', overflowLine:2},
          {id: 'currency', header: '币种', field: 'currency', minWidth: '60px'},
          {id: 'excludeTaxPrice', header: '不含税单价', field: 'excludeTaxPrice', minWidth: '100px'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', minWidth: '100px'},
          {id: 'invoiceTaxRate', header: '票面税率', field: 'invoiceTaxRate', minWidth: '100px'},
          {id: 'actualTaxRate', header: '实际税率', field: 'actualTaxRate', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '130px'},
          {id: 'productInfo0', header: '操作', field: 'slot:op', minWidth: '120px'},
        ],
        tableData: [],
        keyword: null,
        date: null,
        debounceQuery: this._.debounce(this.queryQuoteInfo, 500),
      }
    },
    methods: {
      queryQuoteInfo() {
        const params = {
          sku: this.keyword,
          startCreateTime: isMeaningful(this.date) ? convertToDate(this.date[0]) : null,
          endCreateTime: isMeaningful(this.date) ? convertToDate(this.date[1]) : null,
        };
        this.globalParams = params;
        getQuoteInfo(this.code, params)
          .then((data) => {
            this.tableData = data;
          })
      },
      openQuotedPriceSupplier(item) {
        this.$gjCreate(SupplierAddQuotedPrice, {
          props: {
            sku: item.sku,
            skuName: item.productName,
            code: this.code,
            name: this.name,
          },
          on: {
            quotedSuccess: () => {
              this.queryQuoteInfo();
            }
          }
        })
      },
      openQuotedHistory(item) {
        this.$gjCreate(SupplierQuotedHistory, {
          props: {
            item: item,
            code: this.code,
            mountTo: this.mountTo
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
